import StoryblokVue from 'storyblok-vue'
import Deferred from '../helpers/deferred'
import loadScriptFromUrl from '../helpers/load-script-from-url'
import { isInPreviewMode, isInStoryblokEditor, importAsync } from './utils'

const loadStoryblokApi = importAsync(() =>
  import('./storyblok-api'),
)

const loadStoryblokBridge = () =>
  loadScriptFromUrl(
    `https://app.storyblok.com/f/storyblok-latest.js?t=${
      process.env.VUE_APP_STORYBLOK_TOKEN}`,
  )

const cmsBlockToProperties = (blockArray) => {
  const block = blockArray && blockArray[0]
  if (block) {
    const { _uid, component, ...properties } = block
    return properties
  }
  return null
}

const StoryblokHelper = function ({ deferLoading }) {
  let storyblokApi        = null
  const initialiser       = new Deferred()
  const loadingInProgress = initialiser.promise

  this.loadDependencies = async () => {
    if (isInPreviewMode()) {
      ;[storyblokApi] = await Promise.all([loadStoryblokApi(), loadStoryblokBridge()])
      initialiser.resolve()
    }
  }

  this.getContentUpdates = async (story, contentUpdatedCallback) => {
    if (isInPreviewMode()) {
      await loadingInProgress

      const { content } = await storyblokApi.fetchStory(story.full_slug, { version: 'draft' })
      contentUpdatedCallback(content)

      // eslint-disable-next-line no-undef
      storyblok.on('input', ({ story: updatedStory }) => {
        if (story.full_slug === updatedStory.full_slug)
          contentUpdatedCallback(updatedStory.content)
      })
    }
  }

  this.fetchStoryList = async (startsWith, page, perPage) => {
    const response = await storyblokApi.fetchStoryList(startsWith, page, perPage)
    return response
  }

  this.fetchAsset = async (id, assetCallback) => {
    const { asset } = await storyblokApi.fetchAsset(id)
    // eslint-disable-next-line no-console
    assetCallback(asset)
  }

  this.isInStoryblokEditor = isInStoryblokEditor

  // Fetching dependencies early, to reduce the content loading time in development
  if (!deferLoading)
    this.loadDependencies()
}

export default {
  install (Vue, config = {}) {
    Vue.use(StoryblokVue)
    Vue.prototype.$storyblokHelper = new StoryblokHelper(config)
    Vue.mixin({ methods: { cmsBlockToProps: cmsBlockToProperties } })
  },
}
